<script>
export default {
  props: {
    button: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <router-link class="p-4 md:p-8 m-2 border border-solid border-gray-300 rounded shadow-md" :to="button.route">
    <font-awesome-icon :icon="button.icon" class="block mx-auto mb-6 text-5xl text-airbnbRed" />
    <h2 class="text-center text-2xl tracking-tighter font-bold font-hairline text-lightGrey">
      {{ $t(button.title) }}
    </h2>
  </router-link>
</template>
